module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Bannister\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("ANDREW BANNISTER grew up in Cornwall and studied Geology at Imperial College and went to work in the North Sea before becoming an Environmental Consultant. Andrew is active in volunteer work, focusing on children with special educational needs. "), _c('I', [_vm._v("Creation Machine ")]), _vm._v("is his debut novel.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FkW6XD/tc-custom/9781250179128.jpg?1731883501381",
      "alt": "This image is the cover for the book Creation Machine, Spin Trilogy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Creation Machine, Spin Trilogy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A tyrant’s rebel daughter embarks on a race across an artificial galaxy in this “ambitious, compulsively readable” space opera trilogy debut ("), _c('i', [_vm._v("Guardian")]), _vm._v(", UK).")]), _c('br'), _c('br'), _vm._v("In the vast, artificial galaxy called the Spin, a rebellion has been crushed. Industrialist tyrant Viklun Hass is eliminating all remnants of the opposition—starting with his maverick daughter. But Fleare Hass has had time to plan her next move. And so begins her journey from exile to the very frontiers of a new war."), _c('br'), _c('br'), _vm._v("For hundreds of millions of years, the planets and stars of the Spin have been the only testament to the god-like engineers who created them. Now, beneath the surface of a ruined planet, one of their machines has been found . . . and the Spin will never be the same . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0